import React, { useState, useContext } from 'react';
import { GlobalContext } from '../../context/GlobalContext';
import axios from 'axios';
// import { Link } from 'react-router-dom';
import ImageViewer from '../../components/ImageViewer';
import ArchiveOCR from "./ArchiveOCR"
import SearchArchiveDocuments from "./SearchArchiveDocuments"
import { toast } from "react-toastify";
import TranslationView from '../dashboard/TranslationView';

const ArchiveView = ({ data, text, images, setImages, viewText, setViewText }) => {
    const { API_URL } = useContext(GlobalContext);
    const [isLoading, setIsLoading] = useState({})
    const [selectedImage, setSelectedImage] = useState('');
    const [imageName, setImageName] = useState([]);
    const [folderDir, setFolderDir] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const [editedText, setEditedText] = useState('');
    const [translatedText, setTranslatedText] = useState([])
    // eslint-disable-next-line
    const [textViewSave, setTextViewSave] = useState([]);
    // eslint-disable-next-line
    const [viewedRowIndex, setViewedRowIndex] = useState('')
    // const [message, setMessage] = useState('')
    const [isLoading11, setIsLoading11] = useState(false);

    const storedData = JSON.parse(localStorage.getItem('avatarUser'));
    const authTokenAccess = storedData ? storedData?.access_token : null

    const handleEditClick = () => {
        setIsEditing(true);
    };

    const handleSaveClick = () => {
        setIsEditing(false);
        setTextViewSave(editedText);
    };

    const file = new Blob([editedText], { type: 'text/plain' });
    const fileUrl = URL.createObjectURL(file);

    let fileName = "";

    if (typeof imageName === 'string') {
        fileName = imageName.split('.')[0] + '.txt';
    } else {
        console.error('selectedImage is not a string...');
    }

    const handleSubmit = async (event, taskid, pageid, index) => {
        event.preventDefault();
        setIsLoading({ ...isLoading, [taskid]: true });
        setSelectedImage('')
        setTranslatedText([])

        try {
            const response = await axios.post(`${API_URL}/api/archive`, { "taskid": taskid, "pageid": pageid, "token": authTokenAccess }, {
                headers: {
                    'Content-Type': 'application/json',
                    //Authorization: `Bearer ${authTokenAccess}`,
                },
            });
            if (response.data.imageName.length > 0 && response.status === 200) {
                setImages(response.data.imageName);
                setFolderDir(response.data.folderDir);
                setImageName([])
                setViewText('')
                console.log("archive response:", response.data.imageName);
            } else if (response.data.imageName.length === 0) {
                toast.success("No record found...")
            } else if (response.data.message) {
                toast.success(response.data.message)
            }

        } catch (error) {
            toast.error(error.message)
        } finally {
            console.log("Finally....");
            setIsLoading({ ...isLoading, [taskid]: false });
        }
    };

    const handleTextView = async (event, taskname, index) => {
        event.preventDefault();
        setViewText('')

        setIsLoading({ ...isLoading, [taskname]: true }); // Set loading to true for the specific row
        setViewedRowIndex(index);
        const formData = new FormData();
        formData.append('taskname', taskname);
        formData.append('token', authTokenAccess);

        setIsLoading11(true)

        try {
            const response = await axios.post(`${API_URL}/api/archiveTextView`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    // Authorization: `Bearer ${authTokenAccess}`,
                },
            });

            // console.log("response Tasks:", response.data);

            if (response.data.filename.length > 0 && response.status === 200) {
                setImageName(response.data.filename);
                setViewText(response.data.text);
                setEditedText(response.data.text);
                setTranslatedText(response.data.data);
                setFolderDir(response.data.folderDir);
            } else if (response.data.message && response.status === 200) {
                toast.success(response.data.message)

            }
        } catch (error) {
            alert("Error" + error.message)
            console.error('Error Connection:', error);
        } finally {
            console.log("Finally....");
            setIsLoading11(false)
            setIsLoading({ ...isLoading, [taskname]: false });
        }
    };


    return (
        <>
            <div className='mx-20'>
                {Array.isArray(data) && data.length > 0 ?
                    (<SearchArchiveDocuments data={data} handleSubmit={handleSubmit} isLoading={isLoading} />
                    ) : (
                        <table className="w-full mt-2">
                            <tr>
                                <td className="border border-gray-300 py-3 text-xl text-center" colSpan="3">No Task available</td>
                            </tr>
                        </table>
                    )}

                <div className='mr-14'>
                    {images && images.length > 0 ? (
                        <>
                            <div className='container flex flex-wrap mt-2 border-t-2 border-blue-100'>
                                <div className="w-full sm:w-12">
                                    <h1 className="text-3xl text-center h-10 rounded-full text-slate-900 bg-blue-300 font-bold mb-4 border border-blue-500 -ml-5 -m-1 w-10 border-t-0 -mt-0.5">2</h1>
                                </div>
                            </div>

                            <div className='border-blue-500 container flex border overflow-x-auto -mt-14 ml-14'>
                                <ImageViewer imageName={images} selectedImage={selectedImage} setSelectedImage={setSelectedImage} folderDir={folderDir} />
                            </div>
                        </>
                    ) : ("")
                    }
                </div>

                {images && images.length > 0 ? (
                    <div className='text-center'>
                        {selectedImage &&
                            <button
                                className="text-3xl px-6 py-3 mt-2 bg-blue-300 font-semibold text-gray-900 shadow-md ring-1 ring-inset ring-blue-300 hover:bg-blue-100 rounded ml-auto text"
                                onClick={(e) => { handleTextView(e, selectedImage) }}
                            >
                                {isLoading11 ? (
                                    "Processing, Please wait..."
                                ) : (
                                    'Text View'
                                )}
                            </button>
                        }
                    </div>
                ) : ("")
                }

                {/* view tasks from table */}
                {
                    viewText.length > 0 ? (
                        <div>
                            <div>
                                <ArchiveOCR
                                    API_URL={API_URL}
                                    imageName={selectedImage}
                                    folderDir={folderDir}
                                    editedText={editedText}
                                    isEditing={isEditing}
                                    setEditedText={setEditedText}
                                    handleEditClick={handleEditClick}
                                    handleSaveClick={handleSaveClick}
                                    fileName={fileName}
                                    fileUrl={fileUrl}
                                    searchText={text}
                                />
                            </div>
                        </div>
                    ) : ""
                }

                {translatedText.length > 0 ?
                    <div className='container mt-5 mb-5'>
                        <div className='container flex flex-wrap mt-2 border-t-2 border-blue-100'></div>
                        <div className="flex">
                            <h1 className="text-3xl text-center h-10 rounded-full text-slate-800 bg-blue-300 font-bold mb-4 border border-blue-300 -ml-5 w-10 border-t-0">4</h1>
                            <span className='text-4xl ml-2 font-bold text-slate-800'>Translation</span>
                        </div>

                        <div className='ml-6 -mt-0'>
                            <TranslationView data={translatedText} />
                        </div>
                    </div>
                    : ""}
            </div >
        </>
    );
};

export default ArchiveView;
